import { useEffect, useState } from 'react';
import { subscribePresence, subscribeAllAgentPresence, countOnlineAgents } from '@/services/presenceService';
import type { PresenceRecord } from '@/types/support';

export function usePresence(uid: string | null | undefined) {
  const [presence, setPresence] = useState<PresenceRecord | null>(null);

  useEffect(() => {
    if (!uid) {
      setPresence(null);
      return;
    }
    return subscribePresence(uid, setPresence);
  }, [uid]);

  return presence;
}

export function useOnlineAgentCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    return subscribeAllAgentPresence((map) => {
      setCount(countOnlineAgents(map));
    });
  }, []);

  return count;
}
